export default __webpack_public_path__ + "static/media/Great.77b9c26b.png";